/* APLB — suivi de commande : reconnaît le transporteur au format du numéro
   et ouvre sa page de suivi. Sans correspondance, bascule sur 17track. */
(function () {
  if (customElements.get('aplb-tracking')) return;

  var CARRIERS = [
    { name: 'Chronopost', test: /^[A-Z]{2}\d{9}[A-Z]{2}$/i, url: function (n) { return 'https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=' + n; } },
    { name: 'Colissimo / La Poste', test: /^(?:[0-9A-Z]{2}\d{11}|[A-Z]{2}\d{9}FR|\d{13,15})$/i, url: function (n) { return 'https://www.laposte.fr/outils/suivre-vos-envois?code=' + n; } },
    { name: 'Mondial Relay', test: /^\d{8}$|^\d{10,12}$/, url: function (n) { return 'https://www.mondialrelay.fr/suivi-de-colis/?numeroExpedition=' + n; } },
    { name: 'UPS', test: /^1Z[0-9A-Z]{16}$/i, url: function (n) { return 'https://www.ups.com/track?tracknum=' + n; } },
    { name: 'DHL', test: /^\d{10}$|^JD\d{18}$/i, url: function (n) { return 'https://www.dhl.com/fr-fr/home/tracking.html?tracking-id=' + n; } }
  ];

  class AplbTracking extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.result = this.querySelector('.aplb-track__result');
      this.i18n = window.aplbTrackingI18n || {};
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(evt) {
      evt.preventDefault();
      var n = (this.input.value || '').replace(/\s+/g, '').toUpperCase();
      if (n.length < 6) { this.say(this.i18n.invalid || 'Numéro invalide'); return; }
      var carrier = null;
      for (var i = 0; i < CARRIERS.length; i++) {
        if (CARRIERS[i].test.test(n)) { carrier = CARRIERS[i]; break; }
      }
      var url = carrier ? carrier.url(encodeURIComponent(n)) : 'https://t.17track.net/fr#nums=' + encodeURIComponent(n);
      var msg = carrier
        ? (this.i18n.detected || 'Transporteur : {carrier}').replace('{carrier}', carrier.name)
        : (this.i18n.unknown || 'Transporteur non reconnu, ouverture du suivi universel.');
      this.say(msg);
      window.open(url, '_blank', 'noopener');
    }

    say(text) {
      if (!this.result) return;
      this.result.textContent = text;
      this.result.hidden = false;
    }
  }

  customElements.define('aplb-tracking', AplbTracking);
})();
